import { render, staticRenderFns } from "./DeleteProducts.vue?vue&type=template&id=fb2cef8a&"
import script from "./DeleteProducts.vue?vue&type=script&lang=js&"
export * from "./DeleteProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports